import { render, staticRenderFns } from "./all-certificate.vue?vue&type=template&id=e5c31ebe&scoped=true&"
import script from "./all-certificate.vue?vue&type=script&lang=js&"
export * from "./all-certificate.vue?vue&type=script&lang=js&"
import style0 from "./all-certificate.vue?vue&type=style&index=0&id=e5c31ebe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c31ebe",
  null
  
)

export default component.exports